
export const admin = {
  employeeHub: {
    title: "Staff Management",
    invite: "Invite Staff",
    selfDeleteError: "You cannot delete your own account.",
    deleteConfirm: "Are you sure you want to delete this user?",
    edit: "Edit",
    delete: "Delete",
    sidebar: {
      list: "Staff List",
      timeCard: "Time Cards",
      hoursWorked: "Hours Summary"
    },
    headers: {
      employee: "Employee",
      email: "Email",
      role: "Role",
      pin: "PIN",
      status: "Status",
      actions: "Actions",
      clockIn: "Clock In",
      clockOut: "Clock Out",
      duration: "Duration (Hrs)",
      totalHours: "Total Hours"
    }
  },
  settings: {
    description: "System Settings",
    general: "General",
    features: "Feature Toggles",
    systemStatus: "System Status",
    posDevicesPage: {
      title: "POS Devices",
      description: "Manage cash registers and printer connections.",
      addNew: "Add Device",
      table: {
        name: "Device Name",
        store: "Store",
        status: "Status",
        actions: "Actions"
      }
    },
    taxesPage: {
      title: "Tax Settings",
      description: "Manage global tax settings for your store.",
      enable: "Enable Tax",
      taxName: "Tax Name",
      taxRate: "Tax Rate"
    },
    loyaltyPage: {
      title: "Loyalty Program Settings",
      description: "Configure point earning rules.",
      earnRateLabel: "Earning Rate",
      exampleTitle: "Calculation Example",
      examplePurchase: "Customer spends",
      examplePoints: "Points earned",
      relatedTitle: "Manage Rewards",
      relatedLink: "Go to Promotions Page"
    },
    featureToggles: {
      timeClock: {
        title: "Time Clock",
        description: "Track employee shifts and hours."
      },
      lowStockNotifications: {
        title: "Low Stock Alerts",
        description: "Notify when inventory is running low."
      },
      negativeStockAlerts: {
        title: "Negative Stock Alerts",
        description: "Warn when selling items with zero stock."
      }
    }
  },
  reports: {
    loading: "Generating Report...",
    exportCsv: "Export CSV",
    empty: "No data available for this period.",
    filters: {
      employee: "Employee",
      allEmployees: "All Employees"
    },
    sidebar: {
      salesSummary: "Sales Summary",
      salesByProduct: "Sales by Product",
      salesByCategory: "Sales by Category",
      salesByEmployee: "Sales by Staff",
      salesByPayment: "Payment Methods",
      shifts: "Shift Logs",
      taxes: "Tax Report",
      clinicalStats: "Clinical Stats",
      referralStats: "Referral Stats"
    },
    headers: {
      grossSales: "Gross Sales",
      netSales: "Net Sales",
      discounts: "Discounts",
      transactionCount: "Transactions",
      averageSale: "Avg. Ticket",
      product: "Product",
      category: "Category",
      quantity: "Qty",
      itemsSold: "Items Sold",
      employee: "Employee",
      paymentMethod: "Method",
      totalValue: "Total Value",
      discountType: "Discount Type",
      uses: "Uses",
      totalDiscount: "Total Discount",
      date: "Date",
      taxableAmount: "Taxable Amt.",
      taxAmount: "Tax Amt.",
      cashier: "Cashier",
      openedAt: "Opened",
      closedAt: "Closed",
      startAmount: "Start Cash",
      expected: "Expected",
      endAmount: "Counted",
      variance: "Variance"
    },
    clinical: {
      symptoms: "Symptom Statistics",
      doctorPerformance: "Doctor Performance"
    },
    referral: {
      title: "Referral Statistics",
      totalRequests: "Total Requests",
      totalApproved: "Approved Cases",
      topSender: "Top Sender",
      table: {
        sender: "Sender Store",
        total: "Total",
        approved: "Approved",
        rejected: "Rejected",
        pending: "Pending",
        rate: "Approval Rate",
        lastActive: "Last Active"
      }
    }
  },
  auditLogs: {
    title: "Audit Logs (PDPA)",
    subtitle: "Security & Compliance Access Logs",
    filterUser: {
        all: "All Users"
    },
    filterAction: {
        all: "All Actions",
        view: "View (Read Access)",
        login: "Login/Security",
        create: "Create",
        update: "Update",
        delete: "Delete",
        sale: "Sale"
    },
    searchPlaceholder: "Search logs...",
    export: "Export CSV",
    table: {
        timestamp: "Timestamp",
        user: "User",
        action: "Action",
        description: "Description",
        data: "Data"
    },
    pagination: {
        total: "Total: {{count}} logs"
    }
  }
};
